export default "__VITE_ASSET__B5P7Tk9F__"